export const ga4SettingsService = {
    getId: () => window.__ga4_id__,
};
